import {Controller} from "stimulus";
import * as Credential from "../credential";
import {PublicKeyCredentialCreationOptionsJSON} from "@github/webauthn-json/dist/types/basic/json";

export default class AddCredentialsController extends Controller {
  static targets = ["labelInput", "form", "inProgress"];
  static values = {
    options: Object,
    callbackUrl: String,
  };

  declare labelInputTarget: HTMLInputElement;
  declare formTarget: HTMLElement;
  declare inProgressTarget: HTMLElement;
  declare optionsValue: PublicKeyCredentialCreationOptionsJSON;
  declare callbackUrlValue: string;

  register() {
    this.labelInputTarget.reportValidity();
    if (!this.label) return;
    this.hideTarget(this.formTarget);
    this.showTarget(this.inProgressTarget);

    Credential.create(this.callbackUrlValue, this.label, this.optionsValue);
  }

  get label() {
    return this.labelInputTarget.value;
  }

  private hideTarget(target: HTMLElement) {
    target.classList.add("hidden");
  }

  private showTarget(target: HTMLElement) {
    target.classList.remove("hidden");
  }
}
